const content = {
  title: {
    pageTitle: "Sponsoring Activity Qualification (SAQ)",
    pageDescription:
      "This report shows downlines which have completed the SAQ Certification course which allows ABOs to sponsor ABOs.",
  },
  tabs: {
    qualified: "SAQ Completed",
    notQualified: "SAQ Incomplete",
    upForRenewal: "Up For SAQ Renewal",
  },
  table: {
    columns: {
      aboName: "Name / Number",
      saqStatus: "SAQ Status",
      sponsoringYtd: "Annual Sponsoring",
      groupSize: "Group Size",
      annualPPV: "Annual PPV",
      expirationDate: "Expiration Date",
      sponsorName: "Sponsor",
    },
  },
  export: {
    description:
      "This Report will include a list of ABOs in your group with their SAQ Certification course completion status.",
    exportTypeLabel: "SAQ Certification Report",
  },
  emptyState: {
    noResults: "No ABOs match this criteria.",
  },
  filter: {
    groupLeader: {
      allOption: "All ABOs",
    },
  },
  instructionManual: "Instruction Manual",
  learnMore: "Learn More",
} as const;

export default content;
